import React from 'react';
import { getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import resolveURLParams from '__utils/url-params-resolver';
import { ENDPOINTS } from 'constants/endpoints';
import useFlashToggler from 'hooks/use-flash-toggler';
import { COLOR } from 'constants/colors';
import { SuccessButton, SuccessButtonWhiteBg } from 'components/button';
import styled from 'styled-components';
import { getEncryptedUserId } from '__utils/common-utils';
import { CommonStyledComponentProps } from '__utils/type';
import ConfirmationModal from 'components/confirmation-modal';
import moment from 'moment';


export const PlanFormContainer = styled.div<CommonStyledComponentProps>`
    padding: ${(props: any) => !props.isMobile ? "16px 24px" : "16px"};
    margin-top: ${(props: any) => props.isMobile ? "16px" : "0"};
    box-shadow:  ${(props: any) => !props.isMobile ? "" : "0px 0px 4px 1px rgba(224, 224, 224, 0.7)"};
    border-radius: 8px;
    height: auto;
    overflow: auto;
    background-color: ${COLOR.WHITE};
    margin-bottom: 60px;
   
    .grey{
        color: ${COLOR.GREY3};
        margin: 5px 0 12px 0;      
    }

    select {
        border-radius: 2px;
        border: solid 1px ${COLOR.LIGHTGREY};
        background-color: ${COLOR.WHITE};
        padding: 10px;
        margin: 4px 0 16px 0;
        height: 40px;
        vertical-align: middle;
        width: 100%;
    }
    .greenText{
        color: ${COLOR.GREEN};
    }
   
   
`;

export const GreenBgSmallBtn = styled(SuccessButton)`
    width: 101px;
    font-size: 14px;
    font-weight: normal; 
`;

export const DetailsCardContainer = styled.div<CommonStyledComponentProps>`

    margin-top: ${(props: any) => props.isMobile ? "16px" : ""};
    padding: ${(props: any) => !props.isMobile ? "48px" : "0 16px"};
    border-radius: 8px;
    margin-bottom: 60px;
    height: auto;
    overflow: auto;
    background-color: ${COLOR.WHITE};
    .greyTxt{
        color: ${COLOR.GREY3};
    }
    box-shadow:  ${(props: any) => !props.isMobile ? "" : "0px 0px 4px 1px rgba(224, 224, 224, 0.7)"};
`;

export const SubmitButton = styled(SuccessButton) <any>`   
        width: ${(props: any) => props.width ? props.width : '100%'};
        &:disabled{
            background: #A1A6A7 !important;
            color: #fff;
        }
`;

export const WhiteGreenBorderBtn = styled(SuccessButtonWhiteBg) <CommonStyledComponentProps>`
    width: 100px;
    font-size: 14px;
`;

const successpopupText = () => {
    const isBefore3PM = (): boolean => {
        var d = new Date();
        d.setHours(15);
        d.setMinutes(0);
        d.setSeconds(0);
        return d > new Date();
    }
    return isBefore3PM() ? 'Kindly confirm the STP order by clicking on the link before 3 PM today or your order will be cancelled.' : 'Kindly confirm the STP order by clicking on the link before 3 PM next day or your order will be cancelled.'
}

//purpose: show confirmation modal on order punch, params: plan details to show in popup
export const proceedAfterBseOrder = (callBackFunc: any, firstOrderToday: string,startDate: any) => {
    return (<ConfirmationModal
        title='Almost Done!'
        closable={false}
        modalBody={
            <div>
                <p>{firstOrderToday === 'Y' ? 'As you have scheduled your STP order starting today, you shall recieve a verification link on your email.' :
                    `As you have scheduled your STP order on ${moment(startDate).format('Do MMM')}, you will recieve a verification link on your email on that date.`}</p>
                <br />
                <p className='greenBorderBox'>
                    {firstOrderToday === 'Y' ?
                        <span> {successpopupText()}</span>
                        : <span style={{ color: '#354052' }}>Kindly confirm the STP order by clicking on the link before 3 PM today or your order will be cancelled.</span>}
                </p>
                <br />

                <p className='boldFont font14'>After verifying, the updated status will be visible within 24hrs on your My STPs tab.</p>
                <div className='textAlignCenter pb24'>
                    <GreenBgSmallBtn onClick={callBackFunc}> Okay </GreenBgSmallBtn>
                </div>

            </div>}

    />)
}

//purpose: show awaiting modal if agentstatus of order is pending, params: function to be called on clicking ok
export const showAwaitingModal = (awaitingClick?: any) => {
    return (<ConfirmationModal
        title='Awaiting Verification'
        closable={false}
        modalBody={`A Turtlemint money expert will soon help you on a joint call to confirm this order.`}

        footerButtons={<GreenBgSmallBtn onClick={awaitingClick}>
            Okay
        </GreenBgSmallBtn>}
    />)
}


export const StpSwpHelper = () => {
    const flash = useFlashToggler();

    //purpose: punch bse order, params: 2 callback functions, transactionId, o/p: call callbackfunctions on for appropriate response
    const saveBSEorder = (trnxDetailId: string, callBackSuccess: Function, trxnDetails: any, callBackFailure?: Function) => {
        post(resolveURLParams(ENDPOINTS.POST_SAVE_BSE_ORDER, { trnxDetailId: trnxDetailId }, { ucc: getEncryptedUserId() }), {}, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.meta?.message === 'success') {
                    callBackSuccess(trxnDetails);
                }
                else if (response?.response?.meta?.message === 'failure' && response?.response?.meta?.error) {
                    if (response?.response?.meta?.error === "FAILED: NUMBER OF INSTALLMENT IS LESS THAN MINIMUM INSTALLMENT ALLOWED")
                        flash.error("The number installments is less than the allowed installments. Please extend the duration of installments", 4000, callBackFailure);
                    else
                        flash.error(response?.response?.meta?.error, 4000, callBackFailure);
                }
                else {
                    flash.error("Failed to save BSE order. Please try again later", 4000, callBackFailure);
                }
            }, (error: AjaxError) => {
                flash.error("Failed to save BSE order. Please try again later")
            })
    }
    return { saveBSEorder };
}

export const calcWeekDays = (startDate: any, endDate: any) => {
    const day = moment(startDate);
    let weekDays = 0;
    while (day.isSameOrBefore(endDate, 'day')) {
        if (day.day() !== 0 && day.day() !== 6) {
            weekDays++;
        }
        day.add(1, 'd');
    }
    return weekDays;
}



